import React from "react"
import { extractTextFromJSX } from "lib/extract-text-from-jsx"

export function toDataCy(prefix, value) {
    let text = ""
    if (React.isValidElement(value) || Array.isArray(value)) {
        text = extractTextFromJSX(value)
    } else if (typeof value === "string" || typeof value === "number") {
        text = String(value)
    }
    return `${prefix}-${text}`
        .toLowerCase()
        .replace(/\s+/g, "-")
        .replace(/[^a-z0-9-_]/g, "")
}
